import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';

import BillingAddress from './BillingAddress';

import { IInitialState } from 'src/store/initialState';
import { userActions, userDataSel } from 'src/store/modules/user';

const mapStateToProps = (state: IInitialState) => ({
  userData: userDataSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(userActions.getUserDetails());
  }
});

export const pureComponent = BillingAddress;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(BillingAddress));

interface IDispatchFromProps {
  onLoad(): void;
}
